import styled from '@emotion/styled';
import { Modal } from '@lightspeed/flame/Modal';

export const StyledModal = styled(Modal)`
  @media screen and (max-height: 850px) {
    align-self: baseline;
    margin-top: 320px;
  }
`;
